import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { selectColorList } from '../select-color-list';
import { IEnhanceSlider } from '../types';

const getFeature = () => {
    const { $t } = getLocaleStore();

    const feature: IEnhanceSlider[] = [
        {
            featureType: 'hsl',
            name: $t((v) => v.mainLayer.enhance.config.hslHue),
            keyName: 'hsl_hue',
            maxVal: 100,
            minVal: -100,
            options: {
                blue: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
                green: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
                orange: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
                purple: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
                red: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
                yellow: {
                    lightBackgroundClass: 'sx_1',
                    lightWrapBackgroundClass: '',
                    darkBackgroundClass: 'sx_1',
                    darkWrapBackgroundClass: '',
                },
            },
        },
        {
            featureType: 'hsl',
            name: $t((v) => v.mainLayer.enhance.config.hslSaturation),
            keyName: 'hsl_saturation',
            maxVal: 100,
            minVal: -100,
            opacityOpposite: true,
            options: {
                blue: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                green: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                orange: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                purple: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                red: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
                yellow: {
                    lightBackgroundClass: 'bhd_1',
                    lightWrapBackgroundClass: 'bhd_2',
                    darkBackgroundClass: 'bhd_1',
                    darkWrapBackgroundClass: 'bhd_2',
                },
            },
        },
        {
            featureType: 'hsl',
            name: $t((v) => v.mainLayer.enhance.config.hslLight),
            keyName: 'hsl_light',
            maxVal: 100,
            minVal: -100,
            options: {
                blue: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
                green: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
                orange: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
                purple: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
                red: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
                yellow: {
                    lightBackgroundClass: 'ld_1',
                    lightWrapBackgroundClass: 'ld_2',
                    darkBackgroundClass: 'ld_1',
                    darkWrapBackgroundClass: 'ld_2',
                },
            },
        },
    ];
    return feature;
};

export const getSliderConfig = (theme = AppTheme.white) => {
    const list: Array<IEnhanceSlider[]> = [];

    selectColorList.forEach((color) => {
        const feature = getFeature().map((item) => {
            if (theme == 'dark') {
                item.background = {
                    useStyle: true,
                    classname: item.options?.[color.key].darkBackgroundClass,
                };
                item.wrapBackground = {
                    useStyle: true,
                    classname: item.options?.[color.key].darkWrapBackgroundClass,
                };
            } else {
                item.background = {
                    useStyle: true,
                    classname: item.options?.[color.key].lightBackgroundClass,
                };
                item.wrapBackground = {
                    useStyle: true,
                    classname: item.options?.[color.key].lightWrapBackgroundClass,
                };
            }
            return item;
        });
        list.push(feature);
    });

    return list;
};
